export const setCurrent = (path) => {
  return {
    type: 'SET_CURRENT',
    payload: path
  }
}

export const removeCurrent = (path) => {
  return {
    type: 'REMOVE_CURRENT',
    payload: path
  }
}

export const somethingHovered = (bool) => {
  return {
    type: 'SOMETHING_HOVERED',
    payload: bool
  }
}

export const filterProj = (filter) => {
  return {
    type: 'FILTER_PROJECTS',
    payload: filter
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js